import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';


class Maintenance {

    static getDetailsV2(assetId) {
        const endpoint = formatEndpoint(endpoints.maintenance.getDetailsV2, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getLubricationDetails(assetId) {
        const endpoint = formatEndpoint(endpoints.maintenance.getLubricationDetails, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getLubricationMaintenanceInfo(assetId) {
        const endpoint = formatEndpoint(endpoints.maintenance.getLubricationMaintenanceInfo, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static updateLubricationMaintenanceInfo(payload) {
        const endpoint = formatEndpoint(endpoints.maintenance.updateLubricationMaintenanceInfo);
        return RestManagerWithoutBaseUrl.put(endpoint, payload);
    }

    static getAssetsV2(organizationId, siteIds) {
        const endpoint = formatEndpoint(endpoints.maintenance.getAssetsV2, { organizationId });
        if (siteIds?.length > 0) {
            const queryParams = new URLSearchParams();
            // Add siteIds as individual keys in the query
            siteIds.forEach((siteId) => {
                queryParams.append('siteId', siteId);
            });
            endpoint.url = `${endpoint.url}&${queryParams.toString()}`;
        }
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

}

export default Maintenance;
